import { Link } from "react-router-dom";
import { ActionButton } from "@wine2trace/ui/FormComponents";
import useLabels from "../../hooks/useLabels";
import { Icon } from "../Icon";
import { buildKpis } from "./dashboardKpis";

const PLACEHOLDER_COUNT = 4;

// Informational KPIs ("neutral") carry no status chip.
const STATUS_VISUALS = {
  critical: { labelKey: "homeStatusCritical", icon: "fa-triangle-exclamation" },
  warning: { labelKey: "homeStatusWarning", icon: "fa-triangle-exclamation" },
  ok: { labelKey: "homeStatusOk", icon: "fa-check" },
  unavailable: { labelKey: "homeStatusUnavailable", icon: "fa-minus" },
};

const formatValue = (kpi) => (kpi.value === null ? "—" : `${kpi.value}${kpi.unit ?? ""}`);

// Priority KPIs (max 6) for the sections the server says the user can read. Each card is
// a single link to its detail view; status is written out, never colour only.
const HomeKpis = ({ summary, status, onRetry }) => {
  const [getLabel] = useLabels();

  if (status === "loading") {
    return (
      <div className="home_kpis" data-testid="home-kpis-loading" aria-busy="true">
        {Array.from({ length: PLACEHOLDER_COUNT }, (_, i) => (
          <div key={i} className="home_kpi home_kpi_placeholder" />
        ))}
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="home_kpis_error">
        <p>{getLabel("homeSummaryError")}</p>
        <ActionButton icon="fa-rotate" onClick={onRetry}>
          {getLabel("homeSummaryRetry")}
        </ActionButton>
      </div>
    );
  }

  const kpis = status === "success" ? buildKpis(summary) : [];
  if (kpis.length === 0) return null;

  return (
    <section className="home_kpis" aria-label={getLabel("homeKpiRegion")}>
      <ul className="home_kpis_list">
        {kpis.map((kpi) => {
          const visual = STATUS_VISUALS[kpi.status];
          return (
            <li key={kpi.id}>
              <Link to={kpi.to} className={`home_kpi status_${kpi.status}`}>
                <span className="home_kpi_label">{getLabel(kpi.labelKey)}</span>
                <span className="home_kpi_value">{formatValue(kpi)}</span>
                {visual && (
                  <span className="home_kpi_status">
                    <Icon icon={visual.icon} aria-hidden="true" /> {getLabel(visual.labelKey)}
                  </span>
                )}
                {kpi.contextKey && (
                  <span className="home_kpi_context">{getLabel(kpi.contextKey, kpi.contextTokens)}</span>
                )}
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default HomeKpis;
